import { Color, MeshLambertMaterial } from "three"
import setEmissiveWindowMaterial from "../fn/setEmissiveWindowMaterial"

const windowLightColorYellow = new Color(0xf8f870)

export default function getEntityWindowLightMaterial(
  // engine: Engine,
  // entity: Entity,
): MeshLambertMaterial {
  const material = new MeshLambertMaterial({
    color: windowLightColorYellow,
  })
  material.name = 'WindowLight'
  setEmissiveWindowMaterial(material, windowLightColorYellow)
  return material
}
